module.exports = __webpack_public_path__ + "img/tab31.0f5b7781.png";